/**
 * Client mirror of server/lib/schoolReminderPrefs.js
 */

export function defaultRemindForActionType(actionType) {
  const t = String(actionType || "").toLowerCase();
  return t === "task" || t === "prep" || t === "bring";
}

/**
 * Dated Aufgaben and Termine default the bell on. The parent turns one off
 * in the reminder picker or on the row. Attendance days do not change this.
 *
 * @param {object|null|undefined} raw
 * @param {number[]|unknown} [_kitaWeekdays] kept so callers stay stable
 */
export function defaultRemindForEvent(raw, _kitaWeekdays) {
  const t = String(raw?.action_type || "").toLowerCase();
  if (t === "event") return true;
  return defaultRemindForActionType(t);
}

/**
 * @param {object|null|undefined} raw
 * @param {object|null|undefined} corrections
 * @param {number} index
 * @param {number[]} [kitaWeekdays]
 * @returns {boolean}
 */
export function isSchoolEventRemindEnabled(raw, corrections, index, kitaWeekdays) {
  if (!raw) return false;
  if (corrections?.wrongByIndex?.[index]) return false;

  const explicit = corrections?.remindByIndex?.[index];
  if (explicit === true) return true;
  if (explicit === false) return false;

  return defaultRemindForEvent(raw, kitaWeekdays);
}
